module.exports = __webpack_public_path__ + "img/natalia-perello-byn.5199a076.jpg";